import { render, staticRenderFns } from "./AddNewSurveyDialog.vue?vue&type=template&id=cb2b88d6"
import script from "./AddNewSurveyDialog.vue?vue&type=script&lang=js"
export * from "./AddNewSurveyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports